var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"justify-center",attrs:{"color":"primary","fixed":"","width":"100%","name":"app-bar"}},[_c('v-app-bar-title',[_vm._v("Translate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }